module.exports = __webpack_public_path__ + "img/background-phone.0ee1437d.png";